import React from 'react';
import PropTypes from "prop-types";
import { FaEdit, FaTrash } from 'react-icons/fa';


ElencoNote.propTypes = {
    note: PropTypes.array,
    edit: PropTypes.func,
    openDelete: PropTypes.func,
    lavoratori: PropTypes.object,
    sedi: PropTypes.object
}

function ElencoNote({ note, lavoratori, sedi, edit, openDelete}) {

    const getLavoratore = (idLavoratore) => {
        return lavoratori[idLavoratore]
    }

    const getSedi = (sediKeys) => {
        return sediKeys.map(key => sedi[key]).join(", ");
    }

    const getPeriodoCompetenza = (inizio, fine) => {
        const formatDate = (date) => date.toLocaleDateString("it-IT");
        return `${formatDate(new Date(inizio))} - ${formatDate(new Date(fine))}`;
    };



    const printNote = () => {
        const today = new Date();
        return note.map((nota, index) => {
            const isInactive = new Date(nota.fine) < today;
            const rowClass = isInactive ? "nota-non-attiva" : "";
    
            return (
                <tr key={nota.id} className={rowClass}>
                    <td className="bordiSpessi center">{nota.descrizione}</td>
                    <td className="bordiSpessi center">{getLavoratore(nota.lavoratoreId)}</td>
                    <td className="bordiSpessi center">{getSedi(nota.sedi)}</td>
                    <td className="bordiSpessi center">{getPeriodoCompetenza(nota.inizio, nota.fine)}</td>
                    <td className="bordiSpessi center">{nota.tipo}</td>
                    <td className="bordiSpessi center">
                        {edit(<span id={`modifica-nota-${index}`} className="actionIcon"><FaEdit title='modifica nota' /></span>, nota, index)}
                    </td>
                    <td className="bordiSpessi center">
                        {openDelete(<span id={`elimina-nota-${index}`} className="actionIcon"><FaTrash title='elimina nota' /></span>, nota)}
                    </td>
                </tr>
            );
        });
    };
    

    return (
        note.length > 0 ? (
            <table className="table table-bordered space" id="tabella-note" key="tabellanote">
                <thead className="App">
                    <tr key="intestazione">
                        <th className="inEvidenza bordiSpessi">nota</th>
                        <th className="inEvidenza bordiSpessi">lavoratore</th>
                        <th className="inEvidenza bordiSpessi">sedi</th>
                        <th className="inEvidenza bordiSpessi">periodo di competenza</th>
                        <th className="inEvidenza bordiSpessi">tipo</th>
                        <th className="inEvidenza bordiSpessi">modifica</th>
                        <th className="inEvidenza bordiSpessi">cancella</th>
                    </tr>
                </thead>
                <tbody>
                    {printNote()}
                </tbody>
            </table>
        ) : (
            <p className="text-center" id="note-assenti">Non sono presenti note attive</p>
        )
    );
}

export default ElencoNote;